import CorporateReport from "./files/corporate-report.doc";
import IndividualReport from "./files/individual-report.doc";
import OlNegCorp from "./files/ol-neg-corp.doc";
import olNegIndv from "./files/ol-neg-indv.doc";

export const reports = [
  {
    image: "/assets/building.png",
    file: CorporateReport,
    title: "Corporate Business Reports (CBR)",
    description:
      "A comprehensive report that provides insights into a company’s Operations and Financials.",
    moreInfo: {
      description: [
        "A comprehensive report that provides insights into a company’s Operations and Financials.",
        "CBR also serves as a vital tipping point for investment decision-making, and gives a clear look into the risk factors inherent in a potential investment.",
        "Financing Businesses and distributors may also utilize the CBR to assess borrowers and potential customers. Our reports include trade and client checking to determine the credit standing of a subject (usually Small and Medium Enterprises).",
      ],
      subtitle:
        "The Corporate Business Report includes the following information:",
      list: [
        "Corporate History",
        "Operations",
        "Credit Track Records",
        "Banking Relationships",
        "Financial Condition",
        "Securities and Exchange Commission (SEC) Documents",
        "Related News and Current Developments",
      ],
      buttonLabel: "Download Sample Report",
    },
  },
  {
    image: "/assets/building.png",
    file: IndividualReport,
    title: "Individual Reports (IR)",
    description:
      "Individual Reports are a vital information reference for Human Resource Departments, among others. ",
    moreInfo: {
      description: [
        "Individual Reports are a vital information reference for Human Resource Departments, among others. ",
        "This is a useful tool to choose the right person who can be an asset to their company. The IR may also be used by financial institutions to assess individual credit records.",
      ],
      subtitle: "Individual Reports include the following information:",
      list: [
        "Identity",
        "Reputation",
        "Business Affiliations",
        "Assets",
        "Financial Standing",
        "Negative Records",
      ],
      buttonLabel: "Download Sample Report",
    },
  },
  {
    image: "/assets/building.png",
    file: OlNegCorp,
    title: "Online Negative File Database (NegRec)",
    description:
      "The Negative File Database is an online service that includes listings of:",
    moreInfo: {
      subtitle:
        "The Negative File Database is an online service that includes listings of:",
      list: [
        "Court Cases",
        "Returned Checks",
        "Accounts Endorsed to Legal",
        "Delinquent Accounts from selected companies (Telecommunications, Financing, Distributors)",
      ],
      buttonLabel: "Download Sample Report",
    },
  },
  {
    image: "/assets/building.png",
    title: "Appraisal Reports",
    file: olNegIndv,
    description:
      "An assessment of the fair market value, the appraisal report may cover:",
    moreInfo: {
      subtitle:
        "An assessment of the fair market value, the appraisal report may cover:",
      list: [
        "Land and Improvements",
        "Leasehold Interest",
        "Vehicles/Movable Assets",
        "Furnitures and Fixtures",
      ],
      buttonLabel: "",
    },
  },
];
